import { DefaultPage } from 'pages/App/_NewDefaultPage';
import styled from 'styled-components';
import { GiClover } from 'react-icons/gi';

export const Container = styled(DefaultPage)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Content = styled.div`
    width: 45rem;
    display: flex;
    flex-direction: column;
    padding: 1rem 2rem;
    margin: 0 auto;
    margin-top: 2rem;

    @media (max-width: 750px) {
        width: 30rem;
    }
    @media (max-width: 450px) {
        width: 20rem;
        padding: 1rem;
    }

    h1 {
        width: 100%;
        text-align: center;
        margin-bottom: 1.5rem;
        font-size: 1.7rem;
    }

    span {
        text-align: justify;
        font-size: 1.3rem;
    }
`;

export const BottomBar = styled.div`
    width: 85%;
    height: 2px;
    background-color: var(--black);
    margin: 2rem 0;

    @media (max-width: 1000px) {
        width: 100%;
    }
`;
export const ContainerInfos = styled.div`
    display: flex;
    width: 70%;
    margin: 4rem auto;
    justify-content: center;

    @media (max-width: 900px) {
        width: 100%;
    }

    @media (max-width: 650px) {
        flex-direction: column;
        align-items: center;
    }

    div.texts {
        display: flex;
        flex-direction: column;
        margin-left: 1rem;

        h1 {
            margin-bottom: 1rem;
        }

        ul li {
            font-size: 1.3rem;
        }
    }
`;
export const TicketIcon = styled(GiClover)`
    height: 8rem;
    width: 8rem;

    @media (max-width: 650px) {
        margin-bottom: 2rem;
    }
`;

export const ContainerButton = styled.div`
    width: 45rem;
    margin: 0 auto;
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 750px) {
        width: 30rem;
    }
    @media (max-width: 450px) {
        width: 20rem;
        padding: 1rem;
    }
`;
